import { Switch } from "react-router-dom";

import AuthRoute from "components/AuthRoute";
import EncomendaListaPage from "./Listagem/index";

function EncomendaPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/administracao/encomenda"
        component={EncomendaListaPage}
      />
    </Switch>
  );
}

export default EncomendaPages;
